import styled from 'styled-components';
import colors from 'pubweb-react-components/dist/styles/colors';

import LandingPageStyles from '.././../styles/LandingPageStyles';


export const SubpageBodyContainer = styled.div`

    /* - DESKTOP VIEW - */
    @media screen and (${LandingPageStyles.viewBreakpoints.desktop}){
        display: table;
        max-width: 1750px;
        padding-left: 11.2%;

        .subpage-column-left {
            display: table-cell;
            padding-top: 170px
        }

        .subpage-column-right {
            display: table-cell;
            padding-left: 17px;
            padding-top: 268px;
            width: 483px;
        }

        .subpage-content {
            padding-top: 35px;
        }

        .heading-component {
            display: inline-block;
            max-width: 600px;
        }
        
        .react-bodymovin-container {
            height: 50px;
            width: 50px;
        }

        h2 {
            line-height: 1.14;
            margin-bottom: 25px;
        }

        h3 {
            font-size: 22px;
            margin: 0;
        }
    }

    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {  
        .movin-header svg {
            height: 60px !important;
            width: 60px !important;
        }
    }

    /* - TABLET VIEW - */
    @media screen and (${LandingPageStyles.viewBreakpoints.tablet}){
        display: table;
        padding-left: 5.4%;
        width: 100%;

        .subpage-column-left {
            display: table-cell;
            padding-top: 188px
        }

        .subpage-column-right {
            display: table-cell;
            padding-left: 29px;
            padding-top: 268px;
            width: 375px;
        }

        .subpage-content {
            padding-top: 44px;
        }

        .heading-component {
            display: inline-block;
            max-width: 600px;

            h1 {
                font-size: 32px;
                letter-spacing: -.8px;
            }

            
            h2 {
                font-size: 30px;
                letter-spacing: -2px;
                line-height: 1;
                margin-left: -5px;
                margin-bottom: 25px;
            }

            h3 {
                font-size: 22px;
                margin: 0;
            }
        }
        
        .react-bodymovin-container {
            height: 60px;
            width: 60px;
        }

    }

    /* - MOBILE VIEW - */
    @media screen and (${LandingPageStyles.viewBreakpoints.mobile}){
        display: block;
        padding-left: 15px;
        width: 100%;

        .subpage-column-left {
            display: block;
            padding-top: 202px
        }

        .subpage-column-right {
            display: block;
            padding-left: 0;
            padding-right: 18px;
            padding-top: 20px;
            width: 100%;
        }

        .subpage-content {
            padding-top: 30px;
        }

        .heading-component {
            display: inline-block;
            max-width: 600px;

            h1 {
                font-size: 33px;
                letter-spacing: -.9px;
            }

            h2 {
                font-size: 27px;
                letter-spacing: -.5px;
                line-height: 1.1;
                margin-left: 0px;
                margin-bottom: 25px;
            }

            h3 {
                font-size: 22px;
                margin: 0;
            }
        }
        
        .react-bodymovin-container {
            height: 65px;
            width: 65px;
        }

    }
`;

export const BodyCopyContainer = styled.div`
    color: ${colors.grayscaleCoolGray08};
    font-family: "source-sans-pro", sans-serif;
    font-size: 16px;
    line-height: 27px;
`;


// WEBPACK FOOTER //
// ./src/components/SubpageBody/SubpageBodyStyles.js